import { render, staticRenderFns } from "./MermaidChart.vue?vue&type=template&id=d56df3a2&scoped=true&"
import script from "./MermaidChart.vue?vue&type=script&lang=js&"
export * from "./MermaidChart.vue?vue&type=script&lang=js&"
import style0 from "./MermaidChart.vue?vue&type=style&index=0&id=d56df3a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56df3a2",
  null
  
)

export default component.exports